import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs, Button, Tooltip } from 'antd'
import SalaryList from './components/SalaryList'
import SalaryTransfer from './components/Transfer'
import SalaryPrint from './components/SalaryPrint'

import { connect } from 'react-redux'

import './index.scss'

import { TabsInfoIco } from '../../../modules/CustomIcons'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { dateFormatter, getPathnameByIndex } from '../../services/helper'
import { getCurrentCompany } from '../../services/user'
import GoBack from 'components/goBack'
import { checkAnyPermission } from '../../services/permission'
import { useTranslation } from 'react-i18next'
import noSelected from 'assets/images/noSelectedTransfer.svg'
import { getMessageLists } from 'store/actions/home'
import CustomTooltip from 'components/Tooltip'
import { PlusOutlined } from '@ant-design/icons'
import { ScreenTitle } from 'components/ScreenTitle'
import { useAbility } from '@shared/AccessManager'

const TransferPage: React.FC<any> = ({ companyData, messageList }) => {
  const { t } = useTranslation()

  const language = localStorage.getItem('i18nextLng')
  const [textArray_transfer, setTextArray_transfer] = useState([])
  const [textArray_list, setTextArray_list] = useState([])
  const [textArray_print, setTextArray_print] = useState([])

  const fetchessageData = async () => {
    let lang_text_transfer =
      messageList?.result !== undefined
        ? language == 'az'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_PAY'
            )?.textAZE
          : language == 'ru'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_PAY'
            )?.textRU
          : language == 'en'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_PAY'
            )?.textENG
          : ''
        : ''
    const array_transfer =
      lang_text_transfer !== null && lang_text_transfer !== undefined
        ? lang_text_transfer.split('|')
        : []

    let lang_text_list =
      messageList?.result !== undefined
        ? language == 'az'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_EMPLOYEE'
            )?.textAZE
          : language == 'ru'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_EMPLOYEE'
            )?.textRU
          : language == 'en'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_EMPLOYEE'
            )?.textENG
          : ''
        : ''
    const array_list =
      lang_text_list !== null && lang_text_list !== undefined
        ? lang_text_list.split('|')
        : []

    let lang_text_print =
      messageList?.result !== undefined
        ? language == 'az'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_EMP_LIST'
            )?.textAZE
          : language == 'ru'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_EMP_LIST'
            )?.textRU
          : language == 'en'
          ? messageList.result.find(
              (text) => text.messageKey === 'INFO.SALARY_EMP_LIST'
            )?.textENG
          : ''
        : ''
    const array_print =
      lang_text_print !== null && lang_text_print !== undefined
        ? lang_text_print.split('|')
        : []

    setTextArray_list(array_list)
    setTextArray_transfer(array_transfer)
    setTextArray_print(array_print)
  }
  useEffect(() => {
    fetchessageData()
  }, [messageList, language])

  const TooltipMessageTransfer = `
    ${textArray_transfer
      .map((line: any, index: number) => {
        return line.startsWith('http')
          ? `<a href=${line} key=${index} > ${line} </a>`
          : `<p key=${index} > ${line} </p>`
      })
      .join('')}`

  const TooltipMessageList = `
    ${textArray_list
      .map((line: any, index: number) => {
        return line.startsWith('http')
          ? `<a href=${line} key=${index} > ${line} </a>`
          : `<p key=${index}> ${line} </p>`
      })
      .join('')}`

  const TooltipMessagePrint = `
    ${textArray_print
      .map((line: any, index: number) => {
        return line.startsWith('http')
          ? `<a href=${line} key=${index} > ${line} </a>`
          : `<p key=${index}> ${line} </p>`
      })
      .join('')}`

  const tabData: Array<any> = [
    {
      index: 1,
      title: t('home.transfer'),
      content: <SalaryTransfer />,
      path: '/salary/transfer',
      description: TooltipMessageTransfer,
      permissionKeys: ['SALARY_TOTAL'],
    },
    {
      index: 2,
      title: t('home.listOfEmployees'),
      content: <SalaryList />,
      description: TooltipMessageList,
      path: '/salary/list',
      permissionKeys: ['SALARY_EMP'],
    },
    {
      index: 3,
      title: t('home.statement'),
      content: <SalaryPrint />,
      description: TooltipMessagePrint,
      path: '/salary/print',
      permissionKeys: ['EXTRE_SALARY'],
    },
  ]
  const { TabPane } = Tabs
  const history = useHistory()
  const location = useLocation()
  const find_tab = tabData.find(
    (row) => row.path === `/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`
  )
  const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index)

  useEffect(() => {
    const find_tab = tabData.find(
      (row) => row.path === `/${getPathnameByIndex(0)}/${getPathnameByIndex(1)}`
    )

    setTabActiveKey(find_tab?.index)
  }, [location, companyData])

  const tabOnChange = (activeKey) => {
    setTabActiveKey((old_key) => activeKey)

    const find_row = tabData.find((row) => row.index == activeKey)

    history.push(find_row.path)
  }

  const onClickRight = () => {
    window.location.reload()
  }
  const onClickLeft = () => {
    history.push('/')
  }

  const ability = useAbility()

  return (
    <>
      <Row>
        <Col span={24} className="transfer">
          <ScreenTitle
            onClickRight={onClickRight}
            onClickLeft={onClickLeft}
            leftValue={t('home.salary')}
            rightValue={dateFormatter(new Date())}
            icon={ability.can('view', 'SalaryCardMenuItem') ? <Link to='/orders/salary-card/create'>
                <Tooltip title={t('salary.createNewSalaryCard')} placement="right">
                  <PlusOutlined
                    style={{
                      cursor: 'pointer',
                      fontSize: 16,
                      padding: 8,
                      boxSizing: 'border-box',
                      color: '#fff',
                      background: '#015CD1',
                      borderRadius: 30,
                      border: '5px solid #accaf1',
                    }}
                  />
                </Tooltip>
              </Link>: <></>}
          />

          <Tabs
            type="card"
            id="salaryTab"
            className={
              tabActiveKey
                ? `transfer_parent_tab transfer_parent_tab_${tabActiveKey}`
                : `table-background transfer_parent_tab_${tabActiveKey}`
            }
            activeKey={`${tabActiveKey}`}
            onChange={tabOnChange}
            destroyInactiveTabPane={true}
          >
            {tabData &&
              tabData.map((item, index) => {
                let span_class =
                  tabData.length - 1 == index ? 'is_last_span' : ''

                return (
                  checkAnyPermission(item.permissionKeys) && (
                    <TabPane
                      className={`transfer_child_tabs`}
                      tab={
                        <span
                          className={`flex transfer_child_tabs_${item.index} ${span_class}`}
                        >
                          {item.title}
                          <CustomTooltip
                            overlayClassName={'tabs_tooltip'}
                            // placement="rightTop"
                            title={item.description}
                            style={{ maxHeight: '60px' }}
                          >
                            <Button
                              type={'ghost'}
                              className={'transparent'}
                              icon={<TabsInfoIco />}
                            />
                          </CustomTooltip>
                        </span>
                      }
                      key={item.index}
                    >
                      {item.content}
                    </TabPane>
                  )
                )
              })}
          </Tabs>
        </Col>
        {tabActiveKey === undefined && (
          <span className={'noSelected'}>
            {t('newTransfer.noSelectedTransfer')}
            <img src={noSelected} />
          </span>
        )}
      </Row>
    </>
  )
}
const mapDispatchToProps = { getMessageLists }
const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
  companyData:
    state.user && state.user.companyData.result
      ? state.user.companyData.result.customerNo
      : getCurrentCompany(),
  messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(TransferPage)
